import { Component, OnInit, Input } from '@angular/core';
import { EsperienzeListConfig, Experience, WMAIApiService, AuthService } from '../../core';
import { Status } from '../../core/models/status.model';
import { Router, ActivatedRoute } from '@angular/router';
import { WgisService } from 'src/app/wgis/wgis.service';

@Component({
  selector: 'app-esperienza-admin-list',
  templateUrl: './esperienza-admin-list.component.html'
})
export class EsperienzaAdminListComponent implements OnInit {

  constructor(
    private wgisservice: WgisService,
  ) {
  }
  @Input() results: Experience[] = [];

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  zoomOn(esperienza: Experience){
    this.wgisservice.showEsperienzaByObj(esperienza);
  }
  
  // onMouseEnter(idscheda: number){
  //   this.wgisservice.showSchedaIntenseById(idscheda);
  // }
}
